import React, { useState } from "react";
import { useTransition, animated } from "react-spring";
import ProgressBar from "../ProgressBar";
import NextBackButton from "../NextBackButton";

export const WhatAreYouHopingToAchieve = ({
  formData,
  setForm,
  navigation,
  step,
}) => {
  const loanReason = [
    { id: "Refinance", title: "Refinance" },
    { id: "Purchase", title: "Buy a Home" },
    { id: "Construction - Perm", title: "Build a Home" },
  ];

  // console.log(formData);
  // console.log(formData.loanReason);
  const [error, setError] = useState(false);
  const [isVisible, setIsVisible] = useState(true);

  const transition = useTransition(isVisible, {
    from: { opacity: 0, transform: "translate3d(500px,0px,0)" },
    enter: { opacity: 1, transform: "translate3d(0,0px,0)" },
  });

  const changePath = () => {
    if (formData.loanReason === "") {
      setError(true);
      console.log("error");
    }
    if (formData.loanReason === "Construction - Perm") {
      navigation.go(2);
    } else if (formData.loanReason === "Purchase") {
      navigation.go(13);
    } else if (formData.loanReason === "Refinance") {
      navigation.go(26);
    }
  };

  return (
    <div>
      <ProgressBar width={"5%"} />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex justify-center items-center h-full">
        {transition((style, item) =>
          item ? (
            <animated.div
              style={style}
              className="mx-auto flex flex-col justify-end items-center h-1/2 mb-24"
            >
              <h1 className="py-6 text-4xl text-blue-primary font-semibold text-center">
                What are you hoping to achieve?
              </h1>
              <div>
                <label className="text-base font-medium text-gray-900"></label>
                <fieldset className="">
                  <legend className="sr-only">
                    What are you hoping to achieve?
                  </legend>
                  <div className="space-y-4 mb-36 md:mb-48">
                    {loanReason.map((reason) => (
                      <div key={reason.id} className="flex items-center">
                        <input
                          onChange={setForm}
                          value={reason.id}
                          checked={formData.loanReason === reason.id}
                          id={reason.id}
                          name="loanReason"
                          type="radio"
                          className="h-4 w-4 text-white border-gray-satan"
                        />
                        <label
                          htmlFor={reason.id}
                          className="ml-3 block text-xl font-medium text-gray-satan"
                        >
                          {reason.title}
                        </label>
                      </div>
                    ))}
                    {error ? (
                      <p className="text-red-error">
                        please fill out an answer
                      </p>
                    ) : null}
                  </div>
                </fieldset>
              </div>
            </animated.div>
          ) : null
        )}
      </div>
      <NextBackButton
        callBack={changePath}
        goBack={() => navigation.previous()}
      />
    </div>
  );
};
